module.exports = __webpack_public_path__ + "img/tokelau.90092795.png";